"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBatchActionFilter = void 0;
var react_1 = require("react");
var useFetchList_1 = require("./useFetchList");
/**
 * * useBatchActionFilter *
 */
var useBatchActionFilter = function (fetchListDelegate, options) {
    var _a = options.filter, filter = _a === void 0 ? function () { return true; } : _a, initialIds = options.initialIds;
    var _b = useFetchList_1.useFetchList(fetchListDelegate, { autoFetch: false }), fetch = _b.fetch, fetching = _b.fetching, items = _b.items, rest = __rest(_b, ["fetch", "fetching", "items"]);
    var _c = react_1.useState(), validItems = _c[0], setValidItems = _c[1];
    var _d = react_1.useState(), invalidItems = _d[0], setInvalidItems = _d[1];
    react_1.useEffect(function () {
        if (!fetching && !items.length) {
            fetch({
                criteria: {
                    ids: initialIds,
                },
            }).then(function (_a) {
                var items = _a.items;
                var validItems = items.filter(filter);
                setValidItems(validItems);
                setInvalidItems(items.filter(function (item) { return !validItems.includes(item); }));
            });
        }
    }, [filter, initialIds, fetch, fetching, items]);
    return {
        validItems: validItems,
        invalidItems: invalidItems,
        fetchListResult: __assign({ fetch: fetch, fetching: fetching, items: items }, rest),
    };
};
exports.useBatchActionFilter = useBatchActionFilter;
//# sourceMappingURL=useBatchActionFilter.js.map